// extracted by mini-css-extract-plugin
export var container = "styles-module__container___SvG7k";
export var link = "styles-module__link___qv2Rr";
export var viewFullMap = "styles-module__viewFullMap___DfFzU";
export var germanText = "styles-module__germanText___k749m";
export var mapImage = "styles-module__mapImage___iEltt";
export var expandIcon = "styles-module__expandIcon___TJDi5";